import { render, staticRenderFns } from "./InputTagEmail.vue?vue&type=template&id=8c4a26a6&scoped=true&"
import script from "./InputTagEmail.vue?vue&type=script&lang=js&"
export * from "./InputTagEmail.vue?vue&type=script&lang=js&"
import style0 from "./InputTagEmail.vue?vue&type=style&index=0&id=8c4a26a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4a26a6",
  null
  
)

export default component.exports